
import React, { createContext, Fragment as F, useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import AddLineitemsModal from './AddLineitemsModal'
import IncludeUbprs      from './IncludeUbprs'
import TriSelect         from './TriSelect'

// singular

// import AdvancedReportLineitem  from './AdvancedReportLineitem'
import AdvancedReportEditModal from './AdvancedReportEditModal'
import AdvancedReportShowModal from './AdvancedReportShowModal'
import PdfModal          from './PdfModal'
import ReportModal       from './ReportModal'
import ReportCloneModal  from './ReportCloneModal'
import UnauthorizedContactsModal from './UnauthorizedContactsModal'

// plural
import AdvancedReportsModal from './AdvancedReportsModal'
import ReportsModal         from './ReportsModal'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'
import { AppCtx } from "$src/App"

const ReportsCtx = createContext({})


/**
 * ReportsProvider
**/
const ReportsProvider = ({ children, ...props }) => {

  const apiRouter = useApiRouter()

  const {
    currentUser,
    jwtToken,
    loading, setLoading,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ReportsProvider')

  /* state */

  const [ advancedReport, setAdvancedReport ] = useState({ lineitems: [] })
  const [ advancedReportsList, setAdvancedReportsList ] = useState([])
  const refreshAdvancedReportsList = async () => {
    if (!jwtToken) { return; }
    setLoading(true)
    return fetch(apiRouter.advancedReportsPath()).then(r => r.json()).then(inns => {
      // logg(inns, 'got AdvancedReports')
      setAdvancedReportsList(inns.items)
      setLoading(false)

    })
  }

  const [ pdfModalOpen, setPdfModalOpen ] = useState(false)

  const [ reportsList, setReportsList ] = useState([])
  const refreshReportsList = async () => {
    if (!jwtToken) { return; }
    setLoading(true)
    return fetch(apiRouter.reportsPath()).then(r => r.json()).then(({ items }) => {
      // logg(items, 'got Reports')
      setReportsList(items)
      setLoading(false)
      // toast('Refreshed Single FI Reports list')
    })
    /* try {
      await fetch(apiRouter.reportsPath()).then(r => r.json()).then(({ items }) => {
        // logg(items, 'got Reports')
        setReportsList(items)
      })
      await fetch(apiRouter.advancedReportsPath()).then(r => r.json()).then(({ items }) => {
        // logg(items, 'got AdvancedReports')
        setAdvancedReportsList(items)
      })
      toast('Refreshed Single FI Reports list')
    } catch (err) {
      logg(err, "Could not refresh Reports List")
    } finally {
      setLoading(false)
    } */
  }


  /* get my advanced reports and reports */
  useEffect(() => {
    if (!jwtToken) { return; }
    fetch(apiRouter.advancedReportsPath()).then(r => r.json()).then(({ items }) => {
      // logg(items, 'got AdvancedReports')
      setAdvancedReportsList(items)
    })
    fetch(apiRouter.reportsPath()).then(r => r.json()).then(inns => {
      setReportsList(inns.items)
    })
  }, [ jwtToken ])

  const [ allUbprCodes, setAllUbprCodes ] = useState([])
  useEffect(() => {
    if (!jwtToken) { return; }
    fetch(apiRouter.ubprCodesPath()).then(r => r.json()).then((rows) => {
      // logg(rows, 'all ubpr codes')
      setAllUbprCodes( rows )
    })
  }, [ jwtToken ])

  const [ advancedReportEditModalOpen, setAdvancedReportEditModalOpen ] = useState(false)
  const [ advancedReportShowModalOpen, setAdvancedReportShowModalOpen ] = useState(false)
  const [ advancedReportsModalOpen, setAdvancedReportsModalOpen ] = useState(false)

  const [ unauthorizedContactsModalOpen, setUnauthorizedContactsModalOpen, ] = useState(false)
  const [ includeContacts, _setIncludeContacts ] = useState(false)
  const setIncludeContacts = (which) => {
    if (currentUser.roles.indexOf('Contacts') === -1 &&
        currentUser.roles.indexOf('Internal') === -1 ) {
          if (which===true) {
            setUnauthorizedContactsModalOpen(true)
          }
    } else {
      _setIncludeContacts(which)
    }
  }

  const [ reportModalOpen,  setReportModalOpen  ] = useState(false)
  const [ reportsModalOpen, setReportsModalOpen ] = useState(false)
  const [ reportCloneModalOpen,  setReportCloneModalOpen  ] = useState(false)
  const [ reportShareModalOpen,  setReportShareModalOpen  ] = useState(false)


  return <ReportsCtx.Provider value={{
    advancedReport,              setAdvancedReport,
    advancedReportEditModalOpen, setAdvancedReportEditModalOpen,
    advancedReportShowModalOpen, setAdvancedReportShowModalOpen,
    advancedReportsList,                                   refreshAdvancedReportsList,
    advancedReportsModalOpen, setAdvancedReportsModalOpen,
    allUbprCodes, setAllUbprCodes,
    includeContacts, setIncludeContacts,
    pdfModalOpen, setPdfModalOpen,
    reportModalOpen,  setReportModalOpen,
    reportsList,                           refreshReportsList,
    reportsModalOpen, setReportsModalOpen,
    unauthorizedContactsModalOpen, setUnauthorizedContactsModalOpen,
  }} >
    { children }
  </ReportsCtx.Provider>
}

export {
  AddLineitemsModal,
  IncludeUbprs,
  TriSelect,

  // sg
  AdvancedReportEditModal,
  // AdvancedReportLineitem,
  AdvancedReportShowModal,
  PdfModal,
  ReportModal,
  ReportCloneModal,

  // pl
  AdvancedReportsModal,
  ReportsCtx,
  ReportsModal,
  ReportsProvider,
  UnauthorizedContactsModal,
}
